import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import EntityTypes from '../../types/EntityTypes';
import MentionComponent from './MentionComponent';
import renderInlines from '../utils/renderInlines';
import renderVoidNode from '../utils/renderVoidNode';
export var schema = {
  inlines: _defineProperty({}, EntityTypes.MENTION, {
    isVoid: true
  })
};
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator;

  var Component = decorator(MentionComponent);
  return [_objectSpread({}, renderInlines(_defineProperty({}, EntityTypes.MENTION, function (props, editor) {
    var attributes = props.attributes,
        node = props.node;
    var userId = node.data.get('userId');
    return React.createElement(Component, Object.assign({
      userId: userId
    }, props, attributes), renderVoidNode(node, editor));
  })), {
    schema: schema
  })];
});